import { GetMeQuery, useGetMeQuery } from './generated';
import { unwrapQuery } from './unwrap';

export const useMeQuery = (...args: Parameters<typeof useGetMeQuery>) =>
  unwrapQuery(useGetMeQuery(...args), (raw: GetMeQuery | undefined) => raw?.coreEmployees?.me);
